import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useAuthRoles } from "../useAuthRoles";
import { buildServiceUrl } from "../../utils/urlBuilder";

const REALM_NAME = "DSB";
const DEFAULT_REALM_ROLE = "default-roles-dsb";

export function usePutUserRealmRoles() {
  const { token } = useAuthRoles();

  return useMutation({
    mutationKey: ["userRealmRoles", "update"],
    mutationFn: async ({ userId, roleNames }) => {
      if (!userId) {
        throw new Error("Missing userId");
      }

      const normalizedRoleNames = Array.from(
        new Set((roleNames ?? []).filter(Boolean)),
      );

      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const roleMappingsUrl = buildServiceUrl(
        "keycloak",
        `admin/realms/${REALM_NAME}/users/${userId}/role-mappings/realm`,
      );

      const { data: currentRoles } = await axios.get(roleMappingsUrl, {
        headers,
      });

      if (currentRoles?.length) {
        await axios.delete(roleMappingsUrl, {
          headers,
          data: currentRoles,
        });
      }

      const selectedRoles = await Promise.all(
        normalizedRoleNames.map(async (roleName) => {
          const { data } = await axios.get(
            buildServiceUrl(
              "keycloak",
              `admin/realms/${REALM_NAME}/roles/${roleName}`,
            ),
            { headers },
          );

          return data;
        }),
      );

      const { data: defaultRole } = await axios.get(
        buildServiceUrl(
          "keycloak",
          `admin/realms/${REALM_NAME}/roles/${DEFAULT_REALM_ROLE}`,
        ),
        { headers },
      );

      return axios.post(
        roleMappingsUrl,
        [...selectedRoles, defaultRole],
        {
          headers,
        },
      );
    },
  });
}
